import React, { FC, useLayoutEffect } from 'react'
import classnames from 'classnames'
import { makeStyles, createStyles } from 'transfix-ui/core/styles'

interface IContainerProps {
  className?: string
  hidePadding?: boolean
  fullHeight?: boolean
}

type TClassKey = 'wrapper' | 'container'

const useContainerStyles = makeStyles(() =>
  createStyles<TClassKey, { fullHeight: boolean }>({
    wrapper: {
      height: '100%',
    },
    container: {
      height: ({ fullHeight }) => (fullHeight ? '100%' : 'auto'),
    },
  })
)

export const Container: FC<IContainerProps> = ({
  children,
  className = '',
  fullHeight = false,
  hidePadding = false,
}) => {
  const classes = useContainerStyles({ fullHeight })

  useLayoutEffect(() => {
    window.scrollTo({ top: 0 })
  }, [])
  return (
    <div className={classnames(classes.wrapper, className)} id='main'>
      <div
        className={classnames(classes.container, {
          container: !hidePadding,
        })}>
        {children}
      </div>
    </div>
  )
}
